import arrayMutators from 'final-form-arrays';
import {FieldArray} from 'react-final-form-arrays';

const ArrayMutators = () => ({
  ...arrayMutators,
});

export {ArrayMutators, FieldArray};
